import Actions from "./Actions";
import HeaderTitle from "./HeaderTitle";

const pageHeaderComponents = {
  Actions,
  HeaderTitle
}

export default pageHeaderComponents;